import { useState } from 'react';
import { faqs } from '../../../mocks/britfit';

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => setOpenId(openId === id ? null : id);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-stone-100 text-stone-500 text-xs font-semibold px-4 py-1.5 rounded-full mb-5">
            Common Questions
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-900 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
            Frequently Asked<br />Questions
          </h2>
          <p className="text-stone-400 text-sm mt-4 leading-relaxed">
            Everything you need to know about our mobile tyre fitting service.
          </p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-[#F8F7F4] rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
              >
                <span className="text-stone-900 text-sm font-semibold pr-4 leading-snug group-hover:text-[#1B4332] transition-colors">
                  {faq.question}
                </span>
                <span className={`w-7 h-7 flex-none flex items-center justify-center rounded-full transition-all duration-200 ${
                  openId === faq.id
                    ? 'bg-[#1B4332] text-white rotate-180'
                    : 'bg-white text-stone-400'
                }`}>
                  <i className="ri-arrow-down-s-line text-base" />
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-6 pb-6 text-stone-500 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-stone-400 text-sm mb-4">Still have questions? We&apos;re happy to help.</p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-[#1B4332] text-white text-sm font-semibold px-8 py-3 rounded-full cursor-pointer hover:bg-[#145228] transition-colors whitespace-nowrap"
          >
            <i className="ri-question-answer-line" />
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
